import * as Yup from "yup";

export const membershipSchema = Yup.object().shape({
    name: Yup.string()
        .required('Nome da membership é obrigatório.')
        .min(2, 'Nome muito curto.'),
    type: Yup.string().required('Tipo de contrato é obrigatório.'),
    durationType: Yup.string().required('Formato de duração obrigatório.'),
    duration: Yup.number()
        .required('Duração é obrigatória.')
        .min(1, 'No mínimo 1.'),
    value: Yup.number()
        .required('Valor do contrato obrigatório.')
        .min(0, 'Valor não pode ser negativo.'),
    maxInstallments: Yup.number()
        .required('Número de parcelas obrigatório')
        .min(1, 'No mínimo 1 parcela.'),
    description: Yup.string().nullable(),
    status: Yup.string().oneOf(['active', 'inactive']).required(),
    allowsCancellationByApp: Yup.boolean().nullable(),
    cancellationFee: Yup.number().min(0, 'Não pode ser negativo').nullable(),
    cancellationNoticeDays: Yup.number().min(0, 'Mínimo de 0 dias').nullable(),
    allowsSuspension: Yup.boolean().nullable(),
    maxSuspensionDays: Yup.number().min(0, 'Mínimo de 0 dias').nullable(),
    suspensionFee: Yup.number().min(0, 'Não pode ser negativo').nullable(),
    enrollmentRequired: Yup.boolean().nullable(),
    maxSessionsPerWeek: Yup.number().min(0, 'Mínimo 0 (Ilimitado)').nullable(),
    allowedDaysOfWeek: Yup.array().of(Yup.number().min(0).max(6)).nullable(),
    classPackageValidityMonths: Yup.number().min(1, 'Mínimo 1 mês').nullable(),
    memberXp: Yup.number().min(0, 'Não pode ser negativo').nullable(),
    employeeXp: Yup.number().min(0, 'Não pode ser negativo').nullable(),
    order: Yup.number()
});
